import { Dialog, Transition } from '@headlessui/react';
import { MenuAlt2Icon, XIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import React from 'react';

// import { Fade } from '../Animations';
import { Logo } from '../Elements/Logo';
import { SocialShare } from '../Elements/SocialShare';
import { Navigation } from '../Navigation';

type MobileSidebarProps = {
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
const MobileSidebar = ({ sidebarOpen, setSidebarOpen }: MobileSidebarProps) => {
  return (
    <Transition.Root show={sidebarOpen} as={React.Fragment}>
      <Dialog
        as="div"
        static
        className="fixed inset-0 flex z-50 md:hidden"
        open={sidebarOpen}
        onClose={setSidebarOpen}
      >
        <Transition.Child
          as={React.Fragment}
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-700 delay-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-[85%]" />
        </Transition.Child>
        <Transition.Child
          as={React.Fragment}
          enter="transition ease-in-out duration-700 delay-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="relative flex flex-col flex-1 w-full pt-[30%] pb-4">
            <div className="absolute top-0 right-0 pt-3 pr-3">
              <button
                className="ml-1 flex items-center justify-center h-12 w-12 focus:outline-none"
                onClick={() => setSidebarOpen(false)}
              >
                <span className="sr-only">Close sidebar</span>
                <XIcon className="h-8 w-8 text-white text-opacity-80" aria-hidden="true" />
              </button>
            </div>
            <Logo
              className="mx-auto h-auto w-[70%] max-w-[300px]"
              type="02"
              afterLinking={() => {
                setSidebarOpen(false);
              }}
            />
            <div className="flex items-center flex-grow m-5">
              <Navigation
                className="flex flex-col h-1/2 text-white text-opacity-80"
                onClick={() => {
                  setSidebarOpen(false);
                }}
                enableTrail
              />
            </div>
            <div className="text-center mb-5">
              <SocialShare />
            </div>
          </div>
        </Transition.Child>
      </Dialog>
    </Transition.Root>
  );
};

export const MobileMenu = () => {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  return (
    <>
      <MobileSidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      {!sidebarOpen && (
        <button
          className={clsx(
            'fixed top-0 right-0 z-40 px-5 py-5 opacity-70 bg-white md:hidden',
            'transition duration-500 ease-in-out transform hover:scale-110 focus:outline-none '
          )}
          onClick={() => setSidebarOpen(true)}
        >
          <span className="sr-only">Open sidebar</span>
          <MenuAlt2Icon className="h-6 w-6 text-gray-800" aria-hidden="true" />
        </button>
      )}
    </>
  );
};
